// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-container[data-v-2ad60abe] {\n    padding-bottom: 2em;\n}\n.form-header[data-v-2ad60abe] {\n    height: 20px;\n    margin-right: 2em;\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n.attestation-form-container[data-v-2ad60abe] {\n    margin-top: .5em;\n    padding: 2em;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #f2f3f4;\n}\n.form-action-buttons[data-v-2ad60abe] {\n    margin-top: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
